import { AppstoreOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Skeleton, Space, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useMe } from "@/modules/auth/hooks/useAuth";
import { EmptyState } from "@/shared/components/EmptyState";
import { PageHeader } from "@/shared/components/PageHeader";
import { StatusTag } from "@/shared/components/StatusTag";
import { useUrlTableState } from "@/shared/hooks/useUrlState";
import { StaffFormModal } from "../components/StaffFormModal";
import { StaffTable } from "../components/StaffTable";
import { useStaffStore } from "../store/staff.store";

export function StaffPage() {
	const { page, limit, setPage, getFilter, setFilters } = useUrlTableState();
	const selectedOrgId = getFilter("org") ?? null;

	const { data: meUser, isLoading: isMeLoading } = useMe();
	const openCreateModal = useStaffStore((s) => s.openCreateModal);

	const organizations = meUser?.organizations ?? [];
	const selectedOrg = selectedOrgId ? organizations.find((o) => o.id === selectedOrgId) : null;

	const handleSelectOrg = (id: string) => {
		setFilters({ org: id });
	};

	return (
		<div>
			<PageHeader
				title="Xodimlar"
				action={
					selectedOrgId ? (
						<Space>
							<Button
								type="default"
								icon={<AppstoreOutlined />}
								onClick={() => setFilters({ org: null })}
							>
								Tashkilotlarni ko'rish
							</Button>
							<Button
								type="primary"
								icon={<PlusOutlined />}
								onClick={openCreateModal}
								id="staff-create-btn"
							>
								Qo'shish
							</Button>
						</Space>
					) : undefined
				}
			/>

			{isMeLoading ? (
				<Skeleton active paragraph={{ rows: 5 }} />
			) : organizations.length === 0 ? (
				<EmptyState description="Tashkilot topilmadi — xodimlar ro'yxatini ko'rish uchun tashkilotga qo'shilishingiz kerak" />
			) : selectedOrgId ? (
				<>
					<StaffTable
						organizationId={selectedOrgId}
						organizationName={selectedOrg?.name ?? undefined}
						page={page}
						limit={limit}
						onPageChange={setPage}
					/>
					<StaffFormModal organizationId={selectedOrgId} organizations={organizations} />
				</>
			) : (
				<Table
					dataSource={organizations}
					rowKey="id"
					loading={false}
					onRow={(org) => ({
						onClick: () => handleSelectOrg(org.id),
						className: "cursor-pointer",
					})}
					columns={
						[
							{
								title: "№",
								key: "index",
								width: 60,
								align: "center",
								render: (_: unknown, __: unknown, index: number) => index + 1,
							},
							{
								title: "Nomi",
								dataIndex: "name",
								key: "name",
								ellipsis: true,
								render: (name: string) => <span className="font-medium">{name}</span>,
							},
							{
								title: "Holat",
								key: "isPrimary",
								width: 100,
								render: (_: unknown, org: (typeof organizations)[0]) =>
									org.isPrimary ? <StatusTag tone="processing">Asosiy</StatusTag> : null,
							},
						] as ColumnsType<(typeof organizations)[0]>
					}
					pagination={false}
					locale={{ emptyText: <EmptyState description="Tashkilotlar yo'q" /> }}
				/>
			)}
		</div>
	);
}
